export default __webpack_public_path__ + "static/media/physical.ee8d89ab.svg";